import { isEmpty } from '@ember/utils';
import MailServerModel from 'cio/models/mail-server';

const Validations = {
  address(value: string, model: MailServerModel) {
    if (!model.useApi) {
      if (isEmpty(value)) {
        return "Address can't be blank";
      }

      if (model.providerIsSendgrid && model.username !== 'apikey') {
        return "SendGrid's authentication process has changed. Choose 'Yes' above to switch to API authentication";
      }
    }

    return true;
  },

  password(value: string, model: MailServerModel) {
    if (model.useApi && isEmpty(value)) {
      return "API Key can't be blank";
    }

    return true;
  },

  port: {
    dependentKeys: ['address'],
    validator(value: string) {
      let intValue = parseInt(value);

      if (intValue === 25) {
        return "Port cannot be 25; consult your delivery provider's documentation for alternative ports";
      }

      return true;
    },
  },
};

export default Validations;
